import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Search from "../../../CommonComponents/Search";
import CustomTable from "../../../CommonComponents/customTable";
import IconButton from "../../../CommonComponents/IconButton";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import Loading from "../../../Notification-Loading/Loading/Loading";
import DoubleSlider from "../../../CommonComponents/DoubleSlider";
import Tooltip from "../../../CommonComponents/Tooltip";
// import NameWithResumeAndReport from "../../../CommonComponents/NameWithResumeAndReport";
import ChaptersPopUpView from "../../../CommonComponents/ChaptersPopUpView";
import { UserReportContext } from "../../../../context/UserReportContext";
// import { Box } from "@mui/material";
import AlertContext from "../../../../context/AlertContext";
// import Resume from "../Users/Resume";
import { getDataFromStorage } from "../../../../util";
import { useLocation, useParams } from "react-router-dom";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import UserTestResultReportTableHooks from "../../../../Hooks/UserReport/UserTestResultReportTable/UserTestResultReportTableHooks";
import constants from "../../../../constants";
import { TreeSelect } from "antd";
import ExportPdf from "../../Dashboard/ExportPdf";
import ExportToCsv from "../../Dashboard/ExportToCsv";
import Select from "react-select";
import Button from "../../../Button";
import ApplyFilters from "../../../CommonComponents/ApplyFilters";
import TableRow from "@mui/material/TableRow";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import InputDropdown from "../../../CommonComponents/InputDropdown";

import NameCell from "../../../CommonComponents/NameCell";
import { UserReportProvider } from "../../../../context/UserReportContext";
function valuetext(value) {
  return `${value}°C`;
}

const convertTimeSpent = (time, libType) => {
  if (!time || time <= 0) return "-";

  // Normalize to minutes
  const totalMinutes =
    libType === "Content"
      ? Math.floor(time / 60) // seconds → minutes
      : Math.floor(time);     // already minutes

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);

  return parts.join(" ") || "-";
};

const TimeSpent = (Props) => {
  const axios = useAxiosPrivate();
  const [loadingMoreData, setLoadingMoreData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  // const { isLoaded, setIsLoaded } = useAuth();
  const Alert = useContext(AlertContext);
  const { pathname } = useLocation();
  const { renderDataToPDF } = ExportPdf();
  const { downloadIndividualExcel } = ExportToCsv();

  // Double Slider
  const [value, setValue] = useState([0, 60, 80]);
  const [newValue, setNewValue] = useState([0, 60, 80]);

  // Search
  const [search, setSearch] = useState("");
  const debouncedSearchText = useDebouncedValue(search);

  // Refresh button
  const [pageNo, setPageNo] = useState(0);
  const [isRefresh, setIsRefresh] = useState(false);

  // Scrolling
  const tableRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  // Download
  const [showDownloadOptionsDropDown, setShowDownloadOptionsDropDown] =
    useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  // Time spent data and table related
  const [timespent, setTimeSpent] = useState([]);
  const countRef = useRef(0);
  const [moduleLabel, setModuleLabel] = useState([]);

  let { id } = useParams();
  const batchId = sessionStorage.getItem("abatchid");

  // Filter API
  const [testList, setTestList] = useState([]);
  const assignList = useRef([]);
  const assignmentsFetched = useRef(false); // Track if already fetched
  const [midId, setMidId] = useState([]);
  const [option, setOption] = useState([]);
  // Filter states
  const [collegeList, setCollegeList] = useState([]);
  const [college, setCollege] = useState({ label: "All", value: 0 });

  const [filtersApplied, setFiltersApplied] = useState(true);
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [filtersProcessed, setFiltersProcessed] = useState(false); // to track if filters have been processed
  // const [isLoading, setIsLoading] = useState(false);

  //console.log("college selected:", college, collegeList);

  // Resume and reports
  const useCommonFunctionHks = useCommonFunctionHooks();
  const UserReportCxt = useContext(UserReportContext);
  const UserTestResultReportTableHks = UserTestResultReportTableHooks();

  // Table related
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentRow, setCurrentRow] = useState({});
  const [currentCell, setCurrentCell] = useState({});
  // const [reportOpen, setReportOpen] = useState(false);
  // const [selectedRow, setSelectedRow] = useState(null);
  const defaultCollegeRef = useRef(null);

  // Clean scroll handler with useCallback
  const handleScroll = useCallback(() => {
    if (!tableRef.current || loadingMoreData || !hasMore) return;

    // Access the actual scrollable element (.tableWrapper)
    const scrollableElement = tableRef.current.querySelector(".tableWrapper");
    if (!scrollableElement) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollableElement;

    // Trigger load more when near bottom (within 50px)
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadingMoreData(true);
      Alert.setIsLoaded(true);
      setPageNo((prev) => prev + 1);
      setFiltersApplied(true);
    }
  }, [loadingMoreData, hasMore]);

  // Scroll effect
  useEffect(() => {
    const tableElement = tableRef.current;
    if (!tableElement) return;

    // Attach listener to the actual scrollable element
    const scrollableElement = tableElement.querySelector(".tableWrapper");
    if (!scrollableElement) return;

    scrollableElement.addEventListener("scroll", handleScroll);
    return () => {
      scrollableElement.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  // Double slider handler
  const handleChange = (event, newValue, activeThumb) => {
    if (activeThumb === 0) {
      setValue([0, value[1], value[2]]);
    } else {
      setValue(newValue);
    }
  };

  // Apply filters handler
  // const handleApplyFilters = () => {
  //   if (!college) setCollege({ label: "All", value: 0 });
  //   if (option.length === 0) setOption(assignList.current);
  //   setPageNo(0); // Reset to first page when applying new filters
  //   setFiltersApplied(true);
  //   setTimeSpent([]);
  //   setFiltersLoading(true);
  // };

  const handleApplyFilters = () => {
    if (option.length === 0) setOption(assignList.current);
    setPageNo(0);
    setFiltersApplied(true);
    setTimeSpent([]);
    setFiltersLoading(true);
    Alert.setIsLoaded(true);
  };

  // Table row click handler
  const onRowClick = (row, event, cell) => {
    if (cell.key === "Name") return;

    if (anchorEl) {
      setCurrentRow(null);
      setAnchorEl(null);
      setCurrentCell(null);
    } else {
      setCurrentRow(row);
      setAnchorEl(event.currentTarget ?? event.target);
      setCurrentCell(cell);
    }
  };

  // Color calculation based on time percentage
  const getColourBasedOnTimePercentage = (totalTimeStr, timeTakenStr, key) => {
    // console.log("totalTimeStr", totalTimeStr);
    // console.log("timeTakenStr", timeTakenStr);
    let totalTime, timeTaken;

    if (key === "Content") {
      // For Content type, convert seconds to minutes
      totalTime = parseInt(totalTimeStr, 10); //Total is already in minutes no need to change
      timeTaken = parseInt(timeTakenStr, 10) / 60;
    } else {
      // For other types, already in minutes
      totalTime = parseInt(totalTimeStr, 10);
      timeTaken = parseInt(timeTakenStr, 10);
    }

    if (isNaN(timeTaken) || isNaN(totalTime) || totalTime === 0) return null;

    const percent = (timeTaken / totalTime) * 100;
    return checkPercentage(percent);
  };

  const checkPercentage = (percent) => {
    const [v0, v1, v2] = newValue || [0, 50, 100];
    if (v0 <= percent && v1 >= percent) {
      return "red";
    } else if (v1 < percent && v2 >= percent) {
      return "amber";
    } else {
      return "";
    }
  };

  // Render table row
  const renderRow = (row, rowIndex, columns) => {
    // Separate columns into fixed and scrollable for sticky classes
    const fixedLeftColumns = columns.filter((col) => col.fixed === "left");
    const fixedRightColumns = columns.filter((col) => col.fixed === "right");

    return (
      <tr key={rowIndex} className="tableBodyRow" tabIndex={0}>
        {columns.map((col, colIndex) => {
          // Determine sticky class based on column's fixed property
          if (col.key === "Name") {
            return (
              <UserReportProvider key={colIndex}>
                <NameCell
                  row={{
                    ...row,
                    learnerid: row.userId,
                  }}
                  rowIndex={rowIndex} 
                  pos="batch-report-page-container"
                />
              </UserReportProvider>
            );
          }
          let stickyClass = "";
          if (col.fixed === "left") {
            const leftIndex = fixedLeftColumns.findIndex(
              (c) => c.key === col.key
            );
            stickyClass = `stickyLeft-${leftIndex}`;
          } else if (col.fixed === "right") {
            const rightIndex = fixedRightColumns.findIndex(
              (c) => c.key === col.key
            );
            stickyClass = `stickyRight-${rightIndex}`;
          }

          return (
            <td
              key={colIndex}
              onClick={(e) => onRowClick(row, e, col)}
              className={`tableData ${col.key} ${col.className || ""
                } ${stickyClass} ${getColourBasedOnTimePercentage(
                  col.duration,
                  row[col.key],
                  col.key
                )}`}
              style={{ textAlign: col.align || "left" }}
            >
              {col.render ? col.render(row[col.key], row) : row[col.key]}
            </td>
          );
        })}
      </tr>
    );
  };

  // Resume and reports functions
  // const fetchLearnerReport = async (cell) => {
  //   try {
  //     setLoading(true);
  //     console.log("Fetching report data for learner:", cell);
  //     const response = await axios.get(
  //       `node/learner/${cell.userId}/batch/${(Alert.isAdmin && !Alert.isFromProfile.current) ||
  //         (getDataFromStorage("role") === "hr" && !Alert.isFromProfile.current)
  //         ? id
  //         : Alert.isFromProfile.current ||
  //           getDataFromStorage("role") === "customer"
  //           ? Alert.selectedBid.bid
  //           : localStorage.getItem("batchid")
  //       }/testpoints?istagged=false`,
  //       useCommonFunctionHks.getHeaderDetailsForAxios()
  //     );

  //     if (response.data.resultCode !== 1000) {
  //       Alert.setShowNotify({
  //         show: true,
  //         title: "Info",
  //         msg: response.data.msg,
  //       });
  //       throw new Error(
  //         "Something went wrong while fetching report of the student"
  //       );
  //     }

  //     if (
  //       Object.keys(response.data).length === 0 ||
  //       response.data.resultCode === constants.RESULT_STATUS.NO_DATA
  //     ) {
  //       UserReportCxt.setUserTestResultTableData([]);
  //       Alert.setShowNotify({
  //         show: true,
  //         title: "Info",
  //         msg: "No data to display",
  //       });
  //     } else {
  //       response.data.data.data.sort(
  //         (item1, item2) => item1.orderno - item2.orderno
  //       );
  //       UserTestResultReportTableHks.generateDataForUserTestResultReportTable(
  //         response.data.data.data
  //       );
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching report data:", error);
  //     setLoading(false);
  //   }
  // };

  // const handleUserLpData = (cell) => {
  //   setSelectedRow(cell);
  //   setReportOpen(true);
  //   UserReportCxt.setCurrentLearnerDetails({
  //     value: cell?.userId,
  //     label: cell.Name,
  //   });
  //   fetchLearnerReport(cell);
  // };

  // const ViewResume = (row) => {
  //   let learnerId = row.userId;
  //   Alert.setShowNotify({
  //     show: true,
  //     size: "xl",
  //     showClose: true,
  //     hideButton: true,
  //     msg: <Resume from={"onpopup"} learnerId={learnerId} />,
  //   });
  // };

  const handleResponse = (title, msg) => {
    Alert.setShowNotify({
      show: true,
      title: title,
      msg: msg,
    });
  };

  // FIXED: Proper column configuration with fixed property
  const columns = useMemo(() => {
    return moduleLabel?.map((module, index) => ({
      ...module,
      key: module?.key?.trim(),
      title: !module.duration
        ? `${module.title}`
        : `${module.title} (${convertTimeSpent(module.duration)})`, //content is already in minutes for headers
      width: module.key === "Name" ? "250px" : "",
      // FIX: Properly set fixed property for all Name columns
      fixed: module.key === "Name" ? "left" : undefined,
      height: "40px",
      align: module.key === "Name" ? "left" : "center", // Center align all timespent columns

      // FIX: Ensure render function works correctly
      // render:
      //   module.key === "Name"
      //     ? (value, row) => (
      //       <div className="report-time-spent-table-wrapper-name">
      //         {value}
      //         <div className="report-time-spent-table-wrapper-nameButton">
      //           <ActionButtons
      //             row={row}
      //             onViewResume={ViewResume}
      //             onViewReport={handleUserLpData}
      //           />
      //         </div>
      //       </div>
      //     )
      //     : (value, row) => {
      //       return (
      //         <div style={{ textAlign: "center" }}>
      //           {!module.duration || module.duration === 0
      //             ? "-"
      //             : convertTimeSpent(value, module.key)}
      //         </div>
      //       );
      //     },

      render:
        module.key !== "Name"
          ? (value, row) => {
            return (
              <div style={{ textAlign: "center" }}>
                {!module.duration || module.duration === 0
                  ? "-"
                  : convertTimeSpent(value, module.key)}

              </div>
            );
          }
          : undefined,

    }));
  }, [moduleLabel]);


  useEffect(() => {
    // Reset assignments cache on refresh
    if (isRefresh) {
      assignmentsFetched.current = false;
      setFiltersApplied(true);
      setPageNo(0);
      setTimeSpent([]);
      countRef.current = 0;
    }
  }, [isRefresh]);

  // Reset assignments cache when batchId changes
  useEffect(() => {
    assignmentsFetched.current = false;
  }, [batchId]);

  // Filter functions
  const formatTreeData = (data) => {
    return data.map((lp) => ({
      title: lp.lpname,
      value: `lp-${lp.lpid}`,
      children: lp.modules?.map((mod) => ({
        title: mod.mname,
        value: String(mod.mid),
        isLeaf: true,
      })),
    }));
  };

  const extractModules = (selected, tree = testList) => {
    let result = [];
    const traverse = (nodes, parentSelected = false) => {
      for (const node of nodes) {
        const isSelected = selected.includes(node.value) || parentSelected;
        if (node.isLeaf) {
          if (isSelected) result.push(Number(node.value));
        } else if (node.children) {
          traverse(node.children, isSelected);
        }
      }
    };
    traverse(tree);
    return [...new Set(result)];
  };

  const handleInputChange = (value, name) => {
    if (name === "college") {
      setCollege(value ? value : "");
      setFiltersApplied(false);
    }

  };

  const handleChangeForFilter = (newValue = []) => {
    setOption(newValue);
    const selectedModules = extractModules(newValue);
    setMidId(selectedModules);
    setPageNo(0);
  };

  // Add a useEffect to handle debounced search changes
  useEffect(() => {
    if (!filtersProcessed) return;
    // Reset pagination and trigger data fetch
    setPageNo(0);
    setHasMore(true);
    // setTimeSpent([]);
    setFiltersApplied(true);
  }, [debouncedSearchText]);

  // Main data fetch
  useEffect(() => {
    const fetchLpData = async () => {

      if (loading || (!filtersApplied && debouncedSearchText === '')) {
        console.log("API call already in progress...");
        return;
      }

      setLoadingFilter(true);
      setLoadingMoreData(true);
      setLoading(true);
      Alert.setIsLoaded(true);

      try {
        const response = await axios(
          `node/admin/batch/${batchId}/timespent?istimespent=${true}&mid=${midId}&vs=${pageNo}&college=${college && college.value !== 0 ? college.label : ''}&name=${debouncedSearchText}`
        );

        const timespentData = response.data.data.data || [];
        const totalCount = response.data.data.totalCount;
        const modules = response.data.data.modules || [];

        // Check if we have more data to load
        if (pageNo === 0) {
          setTimeSpent(timespentData);
          // If we have total count, use it. Otherwise fall back to length check
          if (totalCount !== undefined) {
            setHasMore(timespentData.length < totalCount);
          } else {
            setHasMore(timespentData?.length >= 10);
          }
        } else {
          setTimeSpent((prev) => {
            const lastPrev = prev.slice(0, 3);
            const lastNew = timespentData.slice(0, 3);
            const isDuplicate =
              JSON.stringify(lastPrev) === JSON.stringify(lastNew);

            if (isDuplicate) {
              setHasMore(false);
              return prev;
            }

            const newData = [...prev, ...timespentData];

            // Update hasMore based on total count or data length
            if (totalCount !== undefined) {
              setHasMore(newData.length < totalCount);
            } else {
              setHasMore(timespentData?.length >= 10);
            }

            return newData;
          });
        }

        setModuleLabel(modules);
        countRef.current++;
      } catch (error) {
        console.error("Error fetching data:", error);
        // Set empty states on error
        setTimeSpent([]);
        setModuleLabel([]);
        setHasMore(false);
      } finally {
        Alert.setIsLoaded(false);
        setLoadingMoreData(false);
        setLoading(false);
        setLoadingFilter(false);
        setFiltersApplied(false);
        setFiltersProcessed(true);
        setIsRefresh(false);
        if (filtersLoading) {
          setFiltersLoading(false);
          Alert.setIsLoaded(false);
        }
      }
    };

    batchId && fetchLpData();
  }, [
    isRefresh,
    batchId,
    filtersApplied,
    debouncedSearchText,
    pageNo,
    midId,
    college
  ]);

  // Filter API call - only once per batchId
  useEffect(() => {
    // Skip if already fetched for this batch
    if (assignmentsFetched.current) return;

    const assignmentResponse = async () => {
      try {
        setTestList([]);
        let response = await axios.get(
          `node/admin/batch/${batchId}/assignments`,
          {
            params: { modules: true },
            headers: { "Content-type": "application/json" },
          }
        );

        if (response?.data?.data?.length > 0) {
          let data = JSON.parse(
            typeof response.data.data === "string" ? response.data.data : "[]"
          );
          const transformedData = formatTreeData(data);
          setTestList(transformedData);
          setOption(transformedData);
          assignList.current = transformedData;
          assignmentsFetched.current = true; // Mark as fetched
          setOption(transformedData.map((lp) => lp.value));
          const aIds = extractModules(transformedData);
          setMidId(aIds);
        }
      } catch (err) {
        if (err.message.includes("403")) {
          Alert.setShowNotify({
            show: true,
            title: "Error",
            msg: "You have been logged-out due to inactivity. Login again.",
          });
          Alert.setIsUnAuth(true);
        } else {
          Alert.setShowNotify({
            show: true,
            title: "Error",
            msg: err.message,
          });
        }
      }
    };

    if (batchId) {
      assignmentResponse();
    }
  }, [batchId]);

  // Fetch college data
  useEffect(() => {
    const responseOfColleges = async () => {
      try {
        const response = await axios.get("node/admin/batch/college", {
          params: { id: batchId, filter: true },
          headers: { "Content-type": "application/json" },
        });

        const transformedData = response.data.data.map((item, index) => ({
          label: item.name,
          value: index + 1,
        }));

        const allOption = { label: "All", value: 0 };

        setCollegeList([allOption, ...transformedData]);
        if (transformedData.length === 1) {
          setCollege(transformedData[0]);
          defaultCollegeRef.current = transformedData[0];
        }
      } catch (err) {
        if (err.message.includes("403")) {
          handleResponse(
            "Error",
            "You have been logged-out due to inactivity. Login again."
          );
          Alert.setIsUnAuth(true);
        } else {
          handleResponse("Error", err.message);
        }
      }
    };
    responseOfColleges();
  }, []);

  // Fetch all data for download (without pagination)
  const fetchAllDataForDownload = async () => {
    try {
      setLoadingDownload(true);
      setLoading(true);
      Alert.setIsLoaded(true);
      // Fetch all data with single API call using getAll=true parameter
      const response = await axios(
        `node/admin/batch/${batchId}/timespent?istimespent=${true}&mid=${midId}&college=${college && college.value !== 0 ? college.label : ''}&name=${debouncedSearchText}&getAll=true`
      );

      const allData = response.data.data.data || [];
      const modules = response.data.data.modules;
      if (modules) setModuleLabel(modules);
      return allData;
    } catch (error) {
      console.error("Error fetching all data for download:", error);
      Alert.setShowNotify({
        show: true,
        title: "Error",
        msg: "Failed to fetch data for download",
      });
      return [];
    } finally {
      setLoadingDownload(false);
      setLoading(false);
      Alert.setIsLoaded(false);
    }
  };

  // Handle PDF download
  const handlePdfDownload = async () => {
    const allData = await fetchAllDataForDownload();
    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);

      // Determine orientation based on number of columns
      // Use landscape if more than 4 columns (Name + 3 modules)
      const numColumns = Object.keys(downloadData[0]).length;
      const orientation = numColumns > 4 ? "landscape" : "portrait";

      renderDataToPDF(downloadData, orientation, "a4", `TimeSpent_Report`);
    }
    setShowDownloadOptionsDropDown(false);
  };

  // Handle CSV download
  const handleCsvDownload = async () => {
    const allData = await fetchAllDataForDownload();
    if (allData && allData.length > 0) {
      const downloadData = prepareDownloadData(allData);
      downloadIndividualExcel(downloadData, `TimeSpent_Report`);
    }
    setShowDownloadOptionsDropDown(false);
  };

  // Prepare data for download (CSV/PDF)
  const prepareDownloadData = (data = timespent) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    if (!moduleLabel || !Array.isArray(moduleLabel)) {
      console.error("moduleLabel is not available");
      return [];
    }

    const result = data.map((student) => {
      const row = {
        Name: student.Name,
      };

      // Add each module's timespent as a column
      // Use module title as-is to preserve formatting
      moduleLabel.forEach(module => {
        if (module.key !== 'Name') {
          console.log("Adding module to download:", module);
          const columnName = `${module.title} (${convertTimeSpent(module.duration, module.key)})`;
          row[columnName] = convertTimeSpent(student[module.key] || 0, module.key);
        }
      });

      return row;
    });
    return result;
  };

  const isReportLoading = loading || loadingFilter || loadingMoreData || filtersLoading;

  return (
    <main className="report-time-spent-container" >
      {(loadingDownload || isReportLoading) && <Loading overlay />}
      <div>
        <section className="report-time-spent-utils-wrapper">
          <div className="report-time-spent-left-util">
            <Search
              placeholder="Search Student"
              value={search}
              width={200}
              onChange={(e) => {
                if (isReportLoading) return;
                setSearch(e.target.value);
              }}
              iconPosition="end"
            />
          </div>
          <div className="report-time-spent-right-util">
            <DoubleSlider
              aria-label="Always visible"
              value={value}
              setValue={setValue}
              newValue={newValue}
              setNewValue={setNewValue}
              onChange={handleChange}
              getAriaValueText={valuetext}
            />

            <TreeSelect
              style={{ width: 180, height: 38 }}
              value={option}
              popupMatchSelectWidth={false}
              listHeight={400}
              treeData={testList}
              placeholder="Assignments"
              treeCheckable={true}
              showCheckedStrategy={TreeSelect.SHOW_PARENT}
              onChange={handleChangeForFilter}
              maxTagCount="responsive"
            />

            {getDataFromStorage("role") !== constants.Roles.hr &&
              parseInt(getDataFromStorage("companyId")) === constants.GRADIOUS_ACCOUNT_ID && (
                <div className="collegeList">
                  <InputDropdown
                    options={collegeList}
                    placeholder="College"
                    disabled={!collegeList}
                    value={college?.value ?? ""}
                    onChange={(selectedValue) => {
                      const selectedOption = collegeList.find(
                        (item) => item.value === selectedValue
                      );

                      handleInputChange(selectedOption, "college");
                    }}
                    className="college-dropdown"
                  />
                </div>
              )}

            {/* Add Apply Filters button */}
            <div className="filter-buttons" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>

              <Button
                size={"sm"}
                // disable={filtersLoading}
                disable={isReportLoading}
                hierarchy={{
                  type: "primary",
                  buttonText: filtersLoading ? 'Applying...' : 'Apply Filters',
                }}
                onClick={handleApplyFilters}
              />
            </div>


            <div
              className="downloadDropdown"
              style={{ position: "relative", zIndex: 1000 }}
            >
              {showDownloadOptionsDropDown && (
                <div
                  className="downloadOptions"
                  onMouseLeave={() => setShowDownloadOptionsDropDown(false)}
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "100%",
                    marginTop: "4px",
                    backgroundColor: "white",
                    border: "1px solid #E4E7EC",
                    borderRadius: "8px",
                    boxShadow:
                      "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    padding: "4px",
                    minWidth: "120px",
                    zIndex: 10, // Fixed: Set very high to appear above header menus
                  }}
                >
                  <div
                    className="option"
                    onClick={handlePdfDownload}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 12px",
                      cursor: loadingDownload ? "not-allowed" : "pointer",
                      borderRadius: "6px",
                      transition: "background-color 0.2s",
                      opacity: loadingDownload ? 0.5 : 1,
                    }}
                    onMouseEnter={(e) =>
                      !loadingDownload &&
                      (e.currentTarget.style.backgroundColor = "#F9FAFB")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <span className="svgiconfordownload">
                      <i
                        className="fa fa-file-pdf-o"
                        style={{
                          color: "red",
                          width: "20px",
                          height: "18px",
                        }}
                      ></i>
                    </span>
                    <p
                      className="optiontext"
                      style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                    >
                      PDF
                    </p>
                  </div>
                  <div
                    className="option"
                    onClick={handleCsvDownload}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      padding: "8px 12px",
                      cursor: loadingDownload ? "not-allowed" : "pointer",
                      borderRadius: "6px",
                      transition: "background-color 0.2s",
                      opacity: loadingDownload ? 0.5 : 1,
                    }}
                    onMouseEnter={(e) =>
                      !loadingDownload &&
                      (e.currentTarget.style.backgroundColor = "#F9FAFB")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <span className="svgiconfordownload">
                      <svg
                        width="20"
                        height="18"
                        viewBox="0 0 20 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8247 1.50248H12.486C12.4596 1.50248 12.4397 1.50248 12.4133 1.50908V-0.00297165L0 1.41664V16.5437L12.4133 18.003V16.4513C12.4397 16.4513 12.4596 16.4579 12.486 16.4579H18.8247C19.135 16.4579 19.4322 16.3391 19.6567 16.1212C19.8745 15.9033 20 15.6127 20 15.3024V2.65797C20 2.34764 19.8745 2.05711 19.6567 1.83922C19.4322 1.62793 19.135 1.50248 18.8247 1.50248ZM3.52592 9.88148C3.73721 9.88148 3.9485 9.84846 4.14658 9.78244L4.25883 10.3965C4.12017 10.4625 3.81644 10.5352 3.41367 10.522C2.31099 10.4955 1.75636 9.76263 1.75636 8.81182C1.75636 7.67613 2.51568 7.02245 3.4863 6.99604C3.86926 6.98283 4.16639 7.06207 4.29845 7.12809L4.14658 7.74876C3.9485 7.66953 3.73721 7.62331 3.51931 7.62991C2.93826 7.63651 2.49587 8.01287 2.49587 8.759C2.50248 9.43909 2.87884 9.86827 3.52592 9.88148ZM5.5926 10.5748C5.20304 10.5616 4.81347 10.4493 4.62859 10.3371L4.78706 9.69C5.05117 9.82866 5.3417 9.90789 5.64543 9.92109C6.00858 9.9277 6.20007 9.77583 6.20007 9.54473C6.20007 9.32024 6.035 9.19478 5.61902 9.04292C5.05117 8.83823 4.68141 8.51469 4.68141 8.01287C4.68141 7.41862 5.16342 6.94982 5.97557 6.93001C6.37174 6.9168 6.66887 6.99604 6.88016 7.08848L6.70188 7.74876C6.47078 7.64312 6.21987 7.58369 5.96236 7.59029C5.62562 7.5969 5.46055 7.75536 5.46055 7.94024C5.46055 8.16474 5.65203 8.26378 6.10102 8.42885C6.72829 8.65995 7.02542 8.99009 7.02542 9.49851C7.01882 10.0994 6.55662 10.6012 5.5926 10.5748ZM9.44206 10.621L8.43843 10.5946L7.25652 6.95642L8.16771 6.93661L8.62331 8.48168C8.74876 8.91746 8.86761 9.34005 8.96005 9.80224H8.97986C9.0723 9.35985 9.19775 8.91746 9.32321 8.49488L9.81842 6.89699L10.7626 6.87058L9.44206 10.621ZM19.3265 15.2958C19.3265 15.4279 19.2737 15.5533 19.1812 15.6458C19.0888 15.7382 18.9567 15.791 18.8247 15.791H12.486C12.4596 15.791 12.4397 15.791 12.4133 15.7844V2.16936C12.4397 2.16276 12.4596 2.16276 12.486 2.16276H18.8247C18.9567 2.16276 19.0888 2.21558 19.1812 2.30802C19.2737 2.40046 19.3265 2.52592 19.3265 2.65797V15.2958Z"
                          fill="#0B8938"
                        />
                      </svg>
                    </span>
                    <p
                      className="optiontext"
                      style={{ margin: 0, fontSize: "14px", fontWeight: 500 }}
                    >
                      CSV
                    </p>
                  </div>
                </div>
              )}
              <Tooltip placement="bottom" title="Download" isIcon={true}>
                <IconButton
                  hierarchy="tertiaryGrey"
                  onClick={() => setShowDownloadOptionsDropDown(true)}
                  disabled={loadingFilter || loadingMoreData || timespent.length === 0 || loadingDownload}
                >
                  <DownloadIcon />
                </IconButton>
              </Tooltip>
            </div>


            <Tooltip placement="bottom" title="Refresh" isIcon={true}>
              <IconButton
                hierarchy="tertiaryGrey"
                // onClick={() => {
                //   setIsRefresh(true);
                //   if (!college) setCollege({ label: "All", value: 0 });
                //   if (!option || option.length === 0) setOption(assignList.current);
                // }}

                onClick={() => {
                  // Force-reset ALL filters back to their default values
                  setSearch("");
                  setCollege({ label: "All", value: 0 });
                  setOption(assignList.current);
                  const aIds = extractModules(assignList.current);
                  setMidId(aIds);
                  setValue([0, 60, 80]);
                  setNewValue([0, 60, 80]);
                  setPageNo(0);
                  setTimeSpent([]);
                  setHasMore(true);
                  setIsRefresh(true);
                }}
                // disabled={loadingMoreData || loading}
                disabled={isReportLoading}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          </div>
        </section>
        <div className="report-time-spent-table-wrapper">
          {/* Proper Table usage with columns that have fixed property */}
          {/* {loading && (<Loading overlay/>)} */}

          {timespent.length > 0 ? (
            <CustomTable
              ref={tableRef}
              columns={columns}
              renderRow={renderRow}
              data={timespent}
              onRowClick={onRowClick}
              emptyText="No time spent data available"
            />
          ) : (
            <TableRow align="center" style={{ height: "450px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
              {!filtersApplied && !filtersProcessed && !loading ? <ApplyFilters type={Props.data.type} text={`Choose an Assignment(s) from the filters above and hit Apply to load the Timespent Report.`} />
                : (!loading && filtersProcessed && <ApplyFilters text="No data available for the selected filters. Try changing the filter options." />)
              }
            </TableRow>
          )}
          {loadingMoreData && timespent.length > 0 && (
            <div
              style={{
                textAlign: "center",
                color: "#667085",
                fontSize: "14px",
              }}
            >
              Loading more data...
            </div>
          )}
          {!hasMore && timespent.length > 0 && (
            <div
              style={{
                textAlign: "center",
                color: "#98A2B3",
                fontSize: "14px",
              }}
            >
              No more data to load
            </div>
          )}
          {/* {reportOpen && selectedRow && (
            <NameWithResumeAndReport
              row={selectedRow}
              reportOpen={reportOpen}
              setReportOpen={setReportOpen}
            />
          )} */}
          <ChaptersPopUpView
            row={currentRow}
            cell={currentCell}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
          />
        </div>
      </div>
    </main>
  );
};

// Refresh Icon Component
const RefreshIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.6665 8.33333C1.6665 8.33333 3.33732 6.05685 4.6947 4.69854C6.05208 3.34022 7.92783 2.5 9.99984 2.5C14.142 2.5 17.4998 5.85786 17.4998 10C17.4998 14.1421 14.142 17.5 9.99984 17.5C6.58059 17.5 3.69576 15.2119 2.79298 12.0833M1.6665 8.33333V3.33333M1.6665 8.33333H6.6665"
      stroke="#667085"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Download Icon Component
const DownloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 12.5V15.8333C17 16.2754 16.8244 16.6993 16.5118 17.0118C16.1993 17.3244 15.7754 17.5 15.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M6.33333 8.33333L10.5 12.5M10.5 12.5L14.6667 8.33333M10.5 12.5V2.5"
      stroke="#667085"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ActionButtons Component
// const ActionButtons = ({ row, onViewResume, onViewReport }) => {
//   const [mouseHoveronSvg, setMouseHoveronSvg] = useState(0);
//   const [hoveredRecordId, setHoveredRecordId] = useState(0);

//   const handleMouseLeave = () => {
//     setMouseHoveronSvg(0);
//     setHoveredRecordId(0);
//   };

//   const handleMouseEnter = (val, id) => {
//     setHoveredRecordId(id);
//     setMouseHoveronSvg(val);
//   };

//   return (
//     <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "0px", ml: "-10px" }}>
//       <Tooltip placement="bottom" title="View Resume" isIcon={true}>
//         <IconButton
//           hierarchy="secondaryGrey"
//           onClick={() => onViewResume(row)}
//           onMouseLeave={handleMouseLeave}
//           onMouseEnter={() => handleMouseEnter(1, row.userId)}
//           size="sm"
//         >
//           <ResumeIcon />
//         </IconButton>
//       </Tooltip>
//       <Tooltip placement="bottom" title="View Report" isIcon={true}>
//         <IconButton
//           hierarchy="secondaryGrey"
//           onClick={() => onViewReport(row)}
//           onMouseLeave={handleMouseLeave}
//           onMouseEnter={() => handleMouseEnter(2)}
//         >
//           <ReportIcon />
//         </IconButton>
//       </Tooltip>
//     </Box>
//   );
// };

// Icon components
// const ResumeIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M9.33317 1.51306V4.26676C9.33317 4.64012 9.33317 4.82681 9.40583 4.96942C9.46975 5.09486 9.57173 5.19684 9.69718 5.26076C9.83978 5.33342 10.0265 5.33342 10.3998 5.33342H13.1535M10.6665 8.66671H5.33317M10.6665 11.3334H5.33317M6.6665 6.00004H5.33317M9.33317 1.33337H5.8665C4.7464 1.33337 4.18635 1.33337 3.75852 1.55136C3.3822 1.74311 3.07624 2.04907 2.88449 2.42539C2.6665 2.85322 2.6665 3.41327 2.6665 4.53337V11.4667C2.6665 12.5868 2.6665 13.1469 2.88449 13.5747C3.07624 13.951 3.3822 14.257 3.75852 14.4487C4.18635 14.6667 4.7464 14.6667 5.8665 14.6667H10.1332C11.2533 14.6667 11.8133 14.6667 12.2412 14.4487C12.6175 14.257 12.9234 13.951 13.1152 13.5747C13.3332 13.1469 13.3332 12.5868 13.3332 11.4667V5.33337L9.33317 1.33337Z"
//       stroke="#F96343"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const ReportIcon = () => (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 16 16"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M9.33317 7.33337H5.33317M6.6665 10H5.33317M10.6665 4.66671H5.33317M13.3332 7.00004V4.53337C13.3332 3.41327 13.3332 2.85322 13.1152 2.42539C12.9234 2.04907 12.6175 1.74311 12.2412 1.55136C11.8133 1.33337 11.2533 1.33337 10.1332 1.33337H5.8665C4.7464 1.33337 4.18635 1.33337 3.75852 1.55136C3.3822 1.74311 3.07624 2.04907 2.88449 2.42539C2.6665 2.85322 2.6665 3.41327 2.6665 4.53337V11.4667C2.6665 12.5868 2.6665 13.1469 2.88449 13.5747C3.07624 13.951 3.3822 14.257 3.75852 14.4487C4.18635 14.6667 4.7464 14.6667 5.8665 14.6667H7.6665M14.6665 14.6667L13.6665 13.6667M14.3332 12C14.3332 13.2887 13.2885 14.3334 11.9998 14.3334C10.7112 14.3334 9.6665 13.2887 9.6665 12C9.6665 10.7114 10.7112 9.66671 11.9998 9.66671C13.2885 9.66671 14.3332 10.7114 14.3332 12Z"
//       stroke="#F96343"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

export default TimeSpent;
